import { DataTypeCoaching } from '@efdigital/ll-addon-data/data-types';
import type { CoachingPlan } from '@efdigital/ll-addon-data/types/coaching/coaching-plan';
import { jsonApiOptions } from '@efdigital/ll-admin-v2/lib/json-api';
import { query } from '@warp-drive/utilities/json-api';

import { page } from '../../json-api.ts';

export function findCoachingPlansByCoachingId(
  coachingId: string,
  { offset, limit }: { offset: number; limit: number }
) {
  return query<CoachingPlan>(
    DataTypeCoaching.CoachingPlan,
    {
      'filter[coaching.id]': coachingId,
      ...page({ offset, limit }),
    },
    jsonApiOptions
  );
}
